import { FC } from 'react';
import { IconColor, IconProps } from '../types';

export const XmarkIcon: FC<IconProps> = ({
  width = 16,
  height = 16,
  fillColor = IconColor.TEXT_PRIMARY,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.83953 12.1796L2.51953 10.8596L5.87953 7.49958L2.51953 4.13958L3.83953 2.81958L7.19953 6.17958L10.5595 2.81958L11.8795 4.13958L8.51953 7.49958L11.8795 10.8596L10.5595 12.1796L7.19953 8.81958L3.83953 12.1796Z"
        fill={fillColor}
      />
    </svg>
  );
};
